import type React from 'react';
import { useEffect, useRef } from 'react';
import type { FixedSizeList } from 'react-window';

import { TABLE_ROW_SIZE } from '../../../constants';

const useVirtualStickyListScroll = (
  tableBodyRef: React.RefObject<HTMLDivElement | null>,
  fixedListRef: React.RefObject<FixedSizeList | null>
) => {
  const fixedListTopOffsetRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = document.documentElement;

      if (tableBodyRef.current && fixedListRef.current) {
        const rect = tableBodyRef.current.getBoundingClientRect();
        const isListSticky = rect.top <= 0;

        if (!fixedListTopOffsetRef.current) fixedListTopOffsetRef.current = scrollTop + rect.top;

        const itemIndex = isListSticky
          ? Math.floor((scrollTop - fixedListTopOffsetRef.current) / TABLE_ROW_SIZE)
          : 0;

        fixedListRef.current.scrollToItem(itemIndex, 'start');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [tableBodyRef, fixedListRef]);
};

export default useVirtualStickyListScroll;
